








































import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

import BuilderTooltip from '@/components/builder/BuilderTooltip.vue'
import BuilderButton from '@/components/builder/BuilderButton.vue'
import { ProfileStubState } from './BuilderProfile.vue'
import BuilderDot from "@/components/builder/BuilderDot.vue"

@Component({
  components: {
    BuilderButton,
    BuilderTooltip,
    BuilderDot
  },
  computed: {
    ...mapGetters('builder', { appType: 'getAppType'}),
  }
})
export default class BuilderProfilePageDescription extends Vue {
  @Prop({ required: true, type: Object }) readonly value!: ProfileStubState

  @Prop({ required: true, type: Number }) readonly step!: number

  appType!: string

  processing = false

  get description(): string | undefined {
    return this.value.description
  }

  set description(description: string | undefined) {
    if(typeof description === 'string' && description.length > 238)  {
      description = description.substring(0,238)
    }
    this.$emit('input', { description })
  }

  get isNextStepDisabled(): boolean {
    return !this.description
  }
  get textFollowMe(): any {
    return  this.appType === 'TYPE_BLOGER' 
      ? this.$t('followMe') 
      : this.$t('followMeStore') 
  }

  async onNextClick(): Promise<void> {
    this.processing = true

    try {
      await this.$store.dispatch('builder/setProfileDescription', {
        description: this.description,
      })

      this.$emit('next')
    } catch (e: any) {
      this.$toasted.error(e.message)
    }

    this.processing = false
  }

  async mounted(): Promise<void> {
    this.$emit('input', {
      highlight: 'description',
      description: this.description
        ? this.description
        : this.textFollowMe,
      blurCover: true,
      blurSubscriptions: true,
      blurContentType: true,
      blurPosts: true
    })
  }
}
